<template>
  <div>
    <header-authenticate></header-authenticate>
    <div class="container">
      <div class="home home--games">
        <div v-if="publishedGames.length == 0" class="home__empty-message">
          {{$t('home.message')}}
        </div>
        <div v-if="publishedGames.length > 0" class="home--games__list">
          <template v-for="(game, idxGame) in publishedGames">
            <card-game :game="game" :key="`game-${idxGame}`" />
          </template>          
          <template v-for="(editorial, idxEditorial) in publishedEditorial">
            <card-editorial :editorial="editorial" :key="`editorial${idxEditorial}`"></card-editorial>
          </template>
        </div>
      </div>
      <div class="social">
        <a href="javascript:;" @click="openLink('https://www.facebook.com/FanfestAPP.HinchaVirtual')">
          <img src="@/assets/redes/facebook.svg" alt="">
        </a>
        <a href="javascript:;" @click="openLink('https://www.youtube.com/channel/UCtb_i8fkMSGouyKO9155FAw/featured')">
          <img src="@/assets/redes/youtube.svg" alt="">
        </a>
        <a href="javascript:;" @click="openLink('https://www.instagram.com/fanfest_app/')">
          <img src="@/assets/redes/instagram.svg" alt="">
        </a>
        <a href="javascript:;" @click="openLink('https://twitter.com/fanfest_app')">
          <img src="@/assets/redes/twitter.svg" alt="">
        </a>
      </div>
    </div>
    <footer-sponsor></footer-sponsor>
  </div>
</template>

<script>
import CardGame from '@/components/Game/CardGame.vue'
import CardEditorial from '@/components/Game/CardEditorial.vue'
import HeaderAuthenticate from '@/components/Header/Authenticate.vue'
import FooterSponsor from '@/components/Footer/Sponsor.vue'
import { mapState } from 'vuex'

export default { 
  components: {
    CardGame,
    CardEditorial,
    HeaderAuthenticate,
    FooterSponsor
  },
  computed: {
    ...mapState({
      publishedGames: state => state.InfoModule.publishedGames,
      publishedEditorial: state => state.InfoModule.publishedEditorial
    })
  },
  created() {
    this.$store.dispatch('getPublishedGames')
    this.$store.dispatch('getPublishedEditorialCards')
  },
  methods: {
    openLink(link) {
      window.open(link, '_system');
    }
  }
}
</script>

<style lang="scss">
@import '@/styles/_variables';

  .social {
    display: none;

    @media (min-width: $break-lg) {
      position: fixed;
      right: $margin-base;
      top: 50%;
      margin-top: -105px;
      display: flex;
      flex-direction: column;
      opacity: .8;

      a {
        margin-bottom: $margin-milli;
        display: block;
      }
    }
  }

  .home__empty-message {
    padding: $margin-base;
    border-radius: $redondeado;
    text-align: center;
    color: $white;
    font-size: $margin-base;
    width: 100%;
    background: $violet;
    margin: $margin-base 0;
  }

</style>